<template>
  <div class='container'>
    <div class='bg-1'>
      <img src='../../assets/img/bg-1.png'>
    </div>
    <div class='logo'>
      <img src='../../assets/img/logo.png'>
    </div>
    <div class='bg-2'>
      <img src='../../assets/img/bg-2.png'>
    </div>
    <div class='content'>
      <div class='txt-1'>
        您好，
        <span class='agent-name'>
          {{ agentLogsResp.uname }}
        </span>
        邀请您在以下商/协会中替 ta本人行使在商/协会内的权力：如编辑资料、发布动态等
      </div>
      <div class='txt-2'>
        <img src='../../assets/img/txt-1.png' alt=''>
        <span class='chamber-name'>{{ agentLogsResp.chamberName }}</span>
      </div>
    </div>
    <div class='btn' @click='goWxApp'>
      <img src='../../assets/img/btn.png' alt=''>
    </div>
  </div>
</template>

<script>
  import { testApi, getChamberMsgById } from '@/api/kd9'

  export default {
    data() {
      return {
        agentLogsResp: {},
        w: 0,
        h: 0,
      }
    },
    created() {
      testApi().then((res) => {
        console.log('res', res)
      })
    },
    mounted() {
      console.log('this.$route', this.$route)
      let id = this.$route.query.id
      if (id) {
        //   let flag = encodeURIComponent(id)
        let fullPath = this.$route.fullPath
        let str = fullPath.slice(5)
        getChamberMsgById(str).then((res) => {
          console.log('res', res)
          this.agentLogsResp = res.data.data.agentLogsResp
        })
      }
    },
    methods: {
      receiveInvitation() {
        window.location.href = 'https://wxaurl.cn/3ACzmMm9Irq'
      },
      goWxApp() {
        if (this.agentLogsResp.h5Url) {
          window.location.href = this.agentLogsResp.h5Url
        }
      },
    },
  }
</script>

<style lang='less'>
  .container {
    width: 100%;
    height: 100vh;
    position: relative;
  }

  .bg-1 {
    width: 100%;
    height: 100vh;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .logo {
    width: 196px;
    height: 196px;
    position: absolute;
    top: 160px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 10;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .bg-2 {
    width: 100%;
    height: calc(100vh - 280px);
    position: absolute;
    top: 280px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .content {
    width: 610px;
    height: auto;
    position: absolute;
    top: 380px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 10;
    font-size: 27px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #222222;
    line-height: 53px;

    .txt-1 {
      width: 100%;
      min-height: 240px;
      opacity: 1;
      background: #ffeded;
      border-radius: 16px;
      margin-bottom: 40px;
      padding: 55px;
      box-sizing: border-box;
    }

    .txt-2 {
      width: 100%;
      min-height: 240px;
      opacity: 1;
      background: #ffeded;
      border-radius: 16px;
      position: relative;
      text-align: center;
      padding: 55px;
      box-sizing: border-box;
      display: table;

      img {
        width: 343px;
        height: 63px;
        position: absolute;
        top: -10px;
        left: 0;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }

    .agent-name {
      color: #e44343;
    }

    .chamber-name {
      margin-top: 30px;
      font-size: 28px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: center;
      color: #dd0000;
      line-height: 53px;
      display: table-cell;
      vertical-align: middle;
    }
  }

  .btn {
    width: 640px;
    height: 130px;
    position: absolute;
    bottom: 90px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 10;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>

